/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Script_LabelInputs */

const en_negotiation_script_label = /** @type {(inputs: Negotiation_Script_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script`)
};

const de_negotiation_script_label = /** @type {(inputs: Negotiation_Script_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script`)
};

const fr_negotiation_script_label = /** @type {(inputs: Negotiation_Script_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script`)
};

const es_negotiation_script_label = /** @type {(inputs: Negotiation_Script_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script`)
};

const it_negotiation_script_label = /** @type {(inputs: Negotiation_Script_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script`)
};

const nl_negotiation_script_label = /** @type {(inputs: Negotiation_Script_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script`)
};

const pl_negotiation_script_label = /** @type {(inputs: Negotiation_Script_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script`)
};

const fi_negotiation_script_label = /** @type {(inputs: Negotiation_Script_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script`)
};

const da_negotiation_script_label = /** @type {(inputs: Negotiation_Script_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script`)
};

const sv_negotiation_script_label = /** @type {(inputs: Negotiation_Script_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script`)
};

/**
* | output |
* | --- |
* | "Script" |
*
* @param {Negotiation_Script_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_script_label = /** @type {((inputs?: Negotiation_Script_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Script_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_script_label(inputs)
	if (locale === "fr") return fr_negotiation_script_label(inputs)
	if (locale === "es") return es_negotiation_script_label(inputs)
	if (locale === "it") return it_negotiation_script_label(inputs)
	if (locale === "nl") return nl_negotiation_script_label(inputs)
	if (locale === "pl") return pl_negotiation_script_label(inputs)
	if (locale === "fi") return fi_negotiation_script_label(inputs)
	if (locale === "da") return da_negotiation_script_label(inputs)
	if (locale === "sv") return sv_negotiation_script_label(inputs)
	return en_negotiation_script_label(inputs)
});